import { DuplicateVersionModel, List, VersionModel } from '@partful/instructions-domain-models';
import { useTenant } from '@providers/Tenant';
import { InfiniteData, QueryClient, useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { instructionQueryKeys } from '../../shared/api/queryKeys';
import { VersionsService } from '../api/versionsService';

export function useDuplicateInstructionVersion() {
  const queryClient = useQueryClient();
  const { accountId } = useTenant();
  const service = useMemo(() => new VersionsService(), []);

  return useMutation<
    VersionModel,
    unknown,
    { instructionId: string; versionId: string; duplicateArgs: DuplicateVersionModel }
  >({
    mutationFn: ({ instructionId, versionId, duplicateArgs }) =>
      service.duplicate(accountId, instructionId, versionId, duplicateArgs),
    onSuccess: (data, { instructionId }) => {
      addDuplicateInstructionVersionToCache(queryClient, data, instructionId);
    },
  });
}

function addDuplicateInstructionVersionToCache(queryClient: QueryClient, version: VersionModel, instructionId: string) {
  queryClient.setQueryData<InfiniteData<List<VersionModel>>>(
    [instructionQueryKeys.listInstructionVersions, instructionId],
    (oldData) => {
      if (oldData) {
        return {
          ...oldData,
          pages: oldData.pages.map((page, index) =>
            index === 0 ? { ...page, items: [version, ...page.items] } : page
          ),
        };
      }
    }
  );
}
